/*
 * Copyright Evollis 2021
 * All Rights Reserved.
 *
 * All information contained herein is, and remains the property of Evollis.
 * The intellectual and technical concepts contained herein are
 * proprietary to Evollis and are protected by trade secret and copyright law.
 * Dissemination of this information or reproduction of this material
 * is STRICTLY FORBIDDEN unless prior written permission is obtained
 * from Evollis.
 */
import { loc } from "../../../../core/utils"
import genericSchema from "../IdentificationPageValidator"
import * as yup from "yup"

/* regex */
const phoneNumberRegex = /^3519[0-9]{8}$/
export const selectNotCorrectValue = () => loc`Please pick a correct value`

const emailRegex = /^[a-zA-Z0-9_\-.]+@[a-zA-Z0-9_\-.]+\.[a-zA-Z0-9_\-.]+$/
const defaultRegex =
  /^[a-zA-ZêëéèçÊËÉÈÇàâäÀÂ' ÄùûüÙÛÜìïîÌÏÎòôöÒÔÖ]+(([ -][a-zA-Z êëéèçÊËÉÈÇàâäÀÂÄùûüÙÛÜìïîÌÏÎòôöÒÔÖ])?[a-zA-ZêëéèçÊËÉÈÇàâäÀÂÄùûüÙÛÜìïîÌÏÎòôöÒÔÖ]*)*$/

/* error messages */
const requiredMessage = () => loc`Required`
const maximumCharactersMessage = (maximumValue) => maximumValue + " " + loc`maximum characters`
const emailNotValidMessage = () => loc`Email invalid`
const phoneNumberInvalidMessage = () => loc`Invalid phone number fnac`
const unauthorizedCharactersMessage = () => loc`Unauthorized characters`

let schema = yup.object().shape({
  identity: yup.object().shape({
    name: yup
      .string()
      .nullable()
      .required(requiredMessage)
      .max(25, maximumCharactersMessage(25))
      .matches(defaultRegex, unauthorizedCharactersMessage()),
    firstName: yup
      .string()
      .nullable()
      .max(25, maximumCharactersMessage(25))
      .required(requiredMessage)
      .matches(defaultRegex, unauthorizedCharactersMessage())
  }),
  coordinates: yup.object().shape({
    phoneNumber: yup
      .string()
      .nullable()
      .required(requiredMessage)
      .test({
        name: "phoneNumber",
        message: "",
        test(value) {
          if (!value) {
            return this.createError({
              message: requiredMessage,
              path: "coordinates.phoneNumber"
            })
          }
          if (!value.replace("+", "").match(phoneNumberRegex)) {
            return this.createError({
              message: phoneNumberInvalidMessage,
              path: "coordinates.phoneNumber"
            })
          }
        }
      }),
    email: yup
      .string()
      .nullable()
      .required(requiredMessage)
      .test({
        name: "email",
        message: "",
        test(value) {
          if (!value?.match(emailRegex)) {
            return this.createError({
              message: emailNotValidMessage,
              path: "coordinates.email"
            })
          }
        }
      })
  })
})

export default (values) => {
  return schema.concat(genericSchema).validate(values, { abortEarly: false, context: values })
}
